import locales from '@/datasources/locales'

export default function (values, separator = ', ', native = false) {
	if (!values || !Array.isArray(values)) { return '' }
	return values.filter(value => locales[value]).map(value => (native
		? locales[value].nativeName
		: locales[value].name)).join(separator)
}
